const GraphNetecs = require('graph-netecs/js/GraphNetecs').GraphNetecs;
const Constants = require('graph-netecs/js/Constants').Constants;
const HorizontalMeasureLine = require('graph-netecs/js/HorizontalMeasureLine').HorizontalMeasureLine;
const VerticalMeasureLine = require('graph-netecs/js/VerticalMeasureLine').VerticalMeasureLine;
const Ppm = require('./ppm').default;
const fanAbstract = require('./fanAbstract').fanAbstract;
const unit = require('./unit').unit;

/**
 * Zbiór wszystkich wykresów zwykłych (bez zbiorczego)
 */
class fanGraphs extends fanAbstract {
    /*
     * createGraphLine pozwala na wykrycie czy jest to measurement tylko do doboru czy do wyświetlenia
     */
    constructor(html, data, store, selectedGraphs, createGraphLine = true) {
        super(html, data, createGraphLine);
        /**
         * obiekt zawierający wykresy
         * kluczem jest nazwa wykresu np. TotalPressure
         * @type {{}}
         */
        this.graphs = {};
        this.store = store;
        this._drawInited = false;
        this.HorizontalColors = ["#FF8C00", "#DC143C", "#CCCC33", "#003399", "#009966", "#FF00FF", "#990000", "#666600", "#33FF66", "#996666", "#008080", "#F5CBA7", "#FA8072", "#44EAC9"];
        this.VerticalColors = ["#00BFFF", "#9932CC"];

        this.types = {
            TotalPressure: 'gp_total_pressure',
            TotalEfficiency: 'gp_total_efficiency',
            PowerOnShaft: 'gp_power_on_shaft',
            PowerOnShaftWithMaterial: 'gp_power_on_shaft_with_material',
            Noise: 'gp_noise',
            StaticPressure: 'gp_static_pressure',
            StaticPressureIncrease: 'gp_static_pressure_increase',
            StaticEfficiency: 'gp_static_efficiency',
            Amperage: 'gp_amperage_v1',
            AmperageV2: 'gp_amperage_v2',
            ElectricalPower: "gp_electrical_power",
        };
        this.unitTypes = {
            TotalPressure: 'pressure',
            TotalEfficiency: 'efficiency',
            PowerOnShaft: 'power',
            PowerOnShaftWithMaterial: 'power',
            Noise: 'noise',
            StaticPressure: 'pressure',
            StaticPressureIncrease: 'pressure',
            StaticEfficiency: 'efficiency',
            Amperage: 'current',
            AmperageV2: 'current',
            ElectricalPower: 'power',
        };
        this.typesAxis = {
            TotalPressure: 'p<sub>F</sub>',
            TotalEfficiency: '&eta;<sub>F</sub>',
            PowerOnShaft: 'P<sub>a</sub>',
            PowerOnShaftWithMaterial: 'P<sub>am</sub>',
            Noise: 'L<sub>A6</sub>',
            StaticPressure: 'p<sub>SF</sub>',
            StaticPressureIncrease: 'p<sub>SPR</sub>',
            StaticEfficiency: '&eta;<sub>SF</sub>',
            Amperage: 'I',
            AmperageV2: 'I',
            ElectricalPower: 'P',
        };


        if(createGraphLine) {
            unit.clearAxisByTypes();
        }

        for (let type in this.types) {
            let graph = new GraphNetecs(unitsList, createGraphLine);

            if(createGraphLine) {
                let title = document.createElement('span');

                title.dataset.forceVueTranslate = "true";
                title.dataset.translateCode = this.types[type];

                if (this.store) {
                    title.innerHTML = this.manageTitle(this.translate(this.types[type]), type);
                } else {
                    title.innerHTML = type;
                }

                if (this.html && (!this.store || type != "AmperageV2" || (this.getActiveFunVoltages()[1]))) {
                    let axisName = `<span class="performance-axis-label" data-force-vue-translate="true" data-translate-code="performance">${this.translate("performance")}</span>`;
                    let axisDescription = new DOMParser().parseFromString(axisName, 'text/html').body.firstChild;

                    if (selectedGraphs === null || selectedGraphs.indexOf(type) !== -1) {
                        if(!this.isParamDisabled(type)) {
                            const graphWrapper = document.createElement("div");
                            graphWrapper.classList.add('graphWrapper')

                            graphWrapper.append(title);
                            graphWrapper.append(graph.html);
                            graph.html.appendChild(axisDescription);
                            graphWrapper.append(this.getLegendForGraphName(type));

                            this.html.append(graphWrapper);
                        }
                    }
                    graph.graph.mouseMove(e => graph.lastMouseMoveEvent = e);
                    $(graph.html).on('contextmenu', e => this.contextMenu(e, graph));
                }
            }

            this.graphs[type] = graph;

            if(createGraphLine) {
                this.setGraphUnitsMenu(this.graphs[type], this.unitTypes[type], this.typesAxis[type]);
            }
        }

        this.graphs.TotalEfficiency.graph.config = {y: {endLimit: 1}};
        this.graphs.StaticEfficiency.graph.config = {y: {endLimit: 1}};
    }

    isParamDisabled(paramKey) {
        let disabled = false;

        if(paramKey==='PowerOnShaftWithMaterial') {
            let activeFan = this.store.state.activeFun;
            if(!activeFan) return false;
            if(activeFan.params.hasOwnProperty('power_on_shaft_with_material')) {
                disabled = activeFan.params.power_on_shaft_with_material === activeFan.params.power_on_shaft;
            } else {
                disabled = true;
            }
        }

        return disabled;
    }

    getLegendElements() {
        return {
            nominalPoint: `<aside class="element">
                <div class="nominal_pkt-dot">
                    <svg class="mark">
                        <g>
                            <circle cx="0" cy="0" r="0"></circle>
                        </g>
                    </svg>
                </div>
                <span class="text" data-force-vue-translate="true" data-translate-code="nominal_point">${this.translate('nominal_point')}</span>
            </aside>`,
            workPoint: `<aside class="element">
                <div class="work_pkt-dot">
                    <svg class="mark">
                        <g>
                            <circle cx="0" cy="0" r="0"></circle>
                        </g>
                    </svg>
                </div>
                <span class="text" data-force-vue-translate="true" data-translate-code="work_point">${this.translate("work_point")}</span>
            </aside>
            `,
            desiredPoint: `<aside class="element">
                <div class="requested_pkt-dot">
                    <svg class="mark">
                        <g>
                            <circle cx="0" cy="0" r="0"></circle>
                        </g>
                    </svg>
                </div>
                <span class="text"  data-force-vue-translate="true" data-translate-code="desired_point">${this.translate("desired_point")}</span>
            </aside>`,
            characteristicLine: `<aside class="element">
                <span class="characteristic-line"></span>
                <span class="text"  data-force-vue-translate="true" data-translate-code="installation_characteristic">${this.translate("installation_characteristic")}</span>
            </aside>`,
            dynamicPressureLine: `<aside class="element">
                <span class="dynamic-pressure"></span>
                <span class="text"  data-force-vue-translate="true" data-translate-code="dynamic_pressure">${this.translate("dynamic_pressure")}</span>
            </aside>`,
            // NVS-86 Definiuję element legendy dla qvmax
            installedPower: `<aside class="element">
                <span class="power-line"></span>
                <span class="text">q<sub>vmax</sub>(${this.store.state.workPointParameters.elements['installed_power'].value}kW)</span>
            </aside>`
        };
    }

    getLegendForGraphName(name) {
        let content = `<aside class="fanGraphSummary-footer" style="position: static; margin-bottom: 30px; margin-top: -30px;">`;

        let types = {
            TotalPressure: ['nominalPoint', 'workPoint', 'desiredPoint', 'characteristicLine', 'dynamicPressureLine'],
            TotalEfficiency: ['nominalPoint', 'workPoint'],
            PowerOnShaft: ['nominalPoint', 'workPoint'],
            PowerOnShaftWithMaterial: ['nominalPoint', 'workPoint'],
            Noise: ['nominalPoint', 'workPoint'],
            StaticPressure: ['nominalPoint', 'workPoint', 'desiredPoint', 'characteristicLine'],
            StaticPressureIncrease: ['nominalPoint', 'workPoint'],
            StaticEfficiency: ['nominalPoint', 'workPoint'],
            Amperage: ['nominalPoint', 'workPoint'],
            AmperageV2: ['nominalPoint', 'workPoint'],
            ElectricalPower: ['nominalPoint', 'workPoint'],
        };

        if(this.getPressureType() === 'static') {
            types.StaticPressure = ['nominalPoint', 'workPoint', 'desiredPoint', 'characteristicLine'];
            types.TotalPressure = ['nominalPoint', 'workPoint', 'dynamicPressureLine'];
        } else {
            types.TotalPressure= ['nominalPoint', 'workPoint', 'desiredPoint', 'characteristicLine', 'dynamicPressureLine'];
            types.StaticPressure = ['nominalPoint', 'workPoint'];
        }
        // NVS-86 Dodaję element legendy tylko gdy jest potrzebny
        if (this.store.state.showPowerLine) types.TotalPressure.push('installedPower')

        if(types.hasOwnProperty(name)) {
            content += `<aside class="elements-container">`;
            for(let key in types[name]){
                if(typeof types[name][key] !== 'string') break;
                content += this.getLegendElements()[types[name][key]];
            }
            content += `</aside>`;
        }

        content += `</div>`;
        return new DOMParser().parseFromString(content, 'text/html').body.firstChild;
    }

    getPressureType() {
        if (this.store.state.fourthStepParametersSelected.pressure.options[0].elements[0].active == true) {
            return this.store.state.fourthStepParametersSelected.pressure.options[0].elements[0].value;
        } else {
            return this.store.state.fourthStepParametersSelected.pressure.options[0].elements[1].value;
        }
    }

    getActiveFunVoltages() {
        if (this.store.state.activeFun && this.store.state.activeFun.data && this.store.state.activeFun.data.network_frequency && this.store.state.activeFun.engine) {
            let frequency = this.getSelectedElementOfOption(this.store.state.fourthStepParametersSelected.network_frequency.options[0].elements);

            let voltage = this.store.state.activeFun.engine['voltage_' + frequency + '_hz'];

            if (voltage) {
                let voltages = voltage.split("/");

                return voltages;
            }
        }

        return [];
    }

    manageTitle(title, type) {
        if (type == "Amperage" || type == "AmperageV2") {
            let voltages = this.getActiveFunVoltages();

            if (type == "Amperage" && voltages[0])
                return title + " (" + voltages[0] + " V)";
            else if (type == "AmperageV2" && voltages[1])
                return title + " (" + voltages[1] + " V)";

            return title + " (-)";
        } else {
            return title;
        }
    }

    getSelectedElementOfOption(elements) {
        for (let elementId in elements) {
            if (elements.hasOwnProperty(elementId) && elements[elementId].active == true)
                return elements[elementId].value;
        }

        return null;
    }

    translate(code, displayErrors = true) {
        let arg = {
            type: 'translate',
            code: code,
            displayErrors: displayErrors,
            out: ""
        }

        this.store.commit(arg);

        return arg.out;

    }

    /**
     * menu pod rpawym klawiszem myszy
     * @param e event
     * @param graph
     * @returns {boolean}
     */
    contextMenu(e, graph) {
        let elementObjectClicked = e.target.findParent(el => el.object);

        if (elementObjectClicked) {
            if (elementObjectClicked.object.contextMenu) {
                elementObjectClicked.object.contextMenu(e);
                return false;
            }
        }

        let contextMenuLastMouseMoveEvent = graph.lastMouseMoveEvent;
        let HorizontalMeasureLineDisable = true;
        let ppmButtons = [];

        if (this.getCountOfGraphLines(graph, HorizontalMeasureLine) < 2) {
            HorizontalMeasureLineDisable = false;
        }

        ppmButtons.push({
            disabled: HorizontalMeasureLineDisable,
            'ico': '',
            'text': this.translate('graph_add_cutoff_line'),
            'func': () => {
                let y = contextMenuLastMouseMoveEvent.y;
                let line = new HorizontalMeasureLine(y);

                line.changed(() => {
                    this.draw();
                    this.changed.call(this);
                });

                //  let linesCount = this.getCountOfGraphLines(graph, HorizontalMeasureLine);
                line.color = this.HorizontalColors[0];
                this.moveColorToLast(this.HorizontalColors, line.color);

                graph.addMeasureLine(line);

                this.changed.call(this);
            }
        });

        let VerticalMeasureLineDisable = true;

        if (this.getCountOfGraphLines(graph, VerticalMeasureLine) < 2) {
            VerticalMeasureLineDisable = false;
        }

        ppmButtons.push({
            disabled: VerticalMeasureLineDisable,
            'ico': '',
            'text': this.translate('graph_add_elevation_line'),
            'func': () => {
                let allLines = [];

                for (let curentType in this.types) {
                    let x = contextMenuLastMouseMoveEvent.x;
                    let line = new VerticalMeasureLine(x, allLines);

                    line.changed(() => {
                        this.draw();
                        this.changed.call(this);
                    });

                    let linesCount = this.getCountOfGraphLines(this.graphs[curentType], VerticalMeasureLine);
                    line.color = this.VerticalColors[linesCount];

                    this.graphs[curentType].addMeasureLine(line);
                    this.changed.call(this);
                }
            }
        });


        if (this.getCountOfGraphLines(graph, HorizontalMeasureLine) > 0) {
            let subMenu = [];
            let count = 0;

            for (let line of graph._measureLines) {
                if (line instanceof HorizontalMeasureLine) {
                    count++;
                    subMenu.push({
                        color: line.color,
                        'ico': '',
                        'text': this.translate('graph_cutoff_line') + count,
                        'func': () => {
                            this.moveColorToFirst(this.HorizontalColors, line.color);
                            graph.removeMeasureLine(line);
                            this.changed.call(this);
                        }
                    })
                }
            }

            ppmButtons.push({
                'ico': '', 'text': this.translate('grap_delete_cutoff_line'), 'func': () => {
                }, sub: subMenu
            });
        }

        if (this.getCountOfGraphLines(graph, VerticalMeasureLine) > 0) {
            let subMenu = [];
            let count = 0;

            for (let line of graph._measureLines) {
                if (line instanceof VerticalMeasureLine) {
                    count++;
                    subMenu.push({
                        color: line.color,
                        'ico': '',
                        'text': this.translate('graph_elevation_line') + count,
                        'func': () => {
                            this.moveColorToLast(this.VerticalColors, line.color);
                            line.remove();
                            this.changed.call(this);
                        }
                    })
                }
            }

            ppmButtons.push({
                'ico': '', 'text': this.translate('grap_delete_elevation_line'), 'func': () => {
                }, sub: subMenu
            });
        }

        let RemoveAllLinesDisable = true;

        if (this.getCountOfGraphLines(graph, HorizontalMeasureLine) > 0 || this.getCountOfGraphLines(graph, VerticalMeasureLine) > 0) {
            RemoveAllLinesDisable = false;
        }

        ppmButtons.push({
            disabled: RemoveAllLinesDisable, 'ico': '', 'text': this.translate('graph_clear_all'), 'func': () => {
                this.removeAllLinesOfType(graph, HorizontalMeasureLine);

                for (let curentType in this.types) {
                    this.removeAllLinesOfType(this.graphs[curentType], VerticalMeasureLine);
                }
            }
        });

        if (graph == this.graphs.TotalPressure || graph == this.graphs.StaticPressure) {
            if (this.fanRecalced.lines.TotalPressure.changingFerequencyEnabled && this.fanRecalced.lines.StaticPressure.changingFerequencyEnabled) {
                ppmButtons.push({
                    'ico': '', 'text': this.translate('graph_block_frequency'), 'func': () => {
                        this.fanRecalced.lines.TotalPressure.changingFerequencyEnabled = false;
                        this.fanRecalced.lines.TotalPressure.line.svg.style.cursor = '';

                        this.fanRecalced.lines.StaticPressure.changingFerequencyEnabled = false;
                        this.fanRecalced.lines.StaticPressure.line.svg.style.cursor = '';
                    }
                });
            } else {
                ppmButtons.push({
                    'ico': '', 'text': this.translate('graph_unlock_frequency'), 'func': () => {
                        this.fanRecalced.lines.TotalPressure.changingFerequencyEnabled = true;
                        this.fanRecalced.lines.TotalPressure.changingTemperatureEnabled = false;
                        this.fanRecalced.lines.TotalPressure.line.svg.style.cursor = 'move';
                        this.fanRecalced.lines.TotalPressure.startPoint.svg.style.cursor = 'move';
                        this.fanRecalced.lines.TotalPressure.endPoint.svg.style.cursor = 'move';

                        this.fanRecalced.lines.StaticPressure.changingFerequencyEnabled = true;
                        this.fanRecalced.lines.StaticPressure.changingTemperatureEnabled = false;
                        this.fanRecalced.lines.StaticPressure.line.svg.style.cursor = 'move';
                        this.fanRecalced.lines.StaticPressure.startPoint.svg.style.cursor = 'move';
                        this.fanRecalced.lines.StaticPressure.endPoint.svg.style.cursor = 'move';
                    }
                });
            }
            // NVS-92 + podbicie wersji biblioteki graphNetecs
            if (this.fanRecalced.lines.TotalPressure.changingTemperatureEnabled && this.fanRecalced.lines.StaticPressure.changingTemperatureEnabled) {
                ppmButtons.push({
                    'ico': '', 'text': this.translate('graph_block_temperature'), 'func': () => {
                        this.fanRecalced.lines.TotalPressure.changingTemperatureEnabled = false;
                        this.fanRecalced.lines.TotalPressure.line.svg.style.cursor = '';

                        this.fanRecalced.lines.StaticPressure.changingTemperatureEnabled = false;
                        this.fanRecalced.lines.StaticPressure.line.svg.style.cursor = '';
                    }
                });
            } else {
                ppmButtons.push({
                    'ico': '', 'text': this.translate('graph_unlock_temperature'), 'func': () => {
                        this.fanRecalced.lines.TotalPressure.changingTemperatureEnabled = true;
                        this.fanRecalced.lines.TotalPressure.changingFerequencyEnabled = false;
                        this.fanRecalced.lines.TotalPressure.line.svg.style.cursor = 'move';
                        this.fanRecalced.lines.TotalPressure.startPoint.svg.style.cursor = 'move';
                        this.fanRecalced.lines.TotalPressure.endPoint.svg.style.cursor = 'move';

                        this.fanRecalced.lines.StaticPressure.changingTemperatureEnabled = true;
                        this.fanRecalced.lines.StaticPressure.changingFerequencyEnabled = false;
                        this.fanRecalced.lines.StaticPressure.line.svg.style.cursor = 'move';
                        this.fanRecalced.lines.StaticPressure.startPoint.svg.style.cursor = 'move';
                        this.fanRecalced.lines.StaticPressure.endPoint.svg.style.cursor = 'move';
                    }
                });
            }
        }

        if (this.requestedPointEnabled) {
            ppmButtons.push({
                'ico': '', 'text': this.translate('graph_block_desired_point'), 'func': () => {
                    this.requestedPointEnabled = false;

                    if (this.requestedPoint)
                        this.requestedPoint.svg.querySelector("circle").style.cursor = '';
                }
            });
        } else {
            ppmButtons.push({
                'ico': '', 'text': this.translate('graph_unlock_desired_point'), 'func': () => {
                    this.requestedPointEnabled = true;

                    if (this.requestedPoint)
                        this.requestedPoint.svg.querySelector("circle").style.cursor = 'move';
                }
            });
        }

        Ppm.show(e, ppmButtons);
        e.preventDefault();

        return false;
    }

    /**
     * wstępne przygotowanie do rysowania wykresów. Wykonuje się tylko raz na jedno wejście na stronę
     * @private
     */
    _drawInit() {
        this._drawInited = true;
        this.createInitialLines();

        this.graphs.TotalPressure.addLine(this.fanRecalced.lines.DynamicPressure);

        this.graphs.TotalPressure.graph.mouseClick(this.totalPressureClick.bind(this));
        this.graphs.StaticPressure.graph.mouseClick(this.staticPressureClick.bind(this));

        this.fanRecalced.lines.TotalPressure.changedFrequency(() => {
            this.dragEventElementType = "frequency";
            this.data.workPointFrequency = this.fanRecalced.lines.TotalPressure.frequency;
            this.data.workPointRotationSpeed = this.data.workPointFrequency / Constants.frequency * this.data.engine_rpm;
            this.changed.call();
        });

        this.fanRecalced.lines.StaticPressure.changedFrequency(() => {
            this.dragEventElementType = "frequency";
            this.data.workPointFrequency = this.fanRecalced.lines.StaticPressure.frequency;
            this.data.workPointRotationSpeed = this.data.workPointFrequency / Constants.frequency * this.data.engine_rpm;
            this.changed.call();
        });

        // NVS-92 Przeciąganie temperatury - ciśnienie całkowite
        this.fanRecalced.lines.TotalPressure.changedTemperature(() => {
            this.dragEventElementType = "temperature";
            this.data.workPointTemperature = this.fanRecalced.lines.TotalPressure.temperature;
            this.data.workPointAirDensity = this.fanRecalced.lines.TotalPressure.density;
            this.store.state.fourthStepParametersSelected.temperature.value = this.fanRecalced.lines.TotalPressure.temperature;
            this.store.state.fourthStepParameters.temperature.value = this.fanRecalced.lines.TotalPressure.temperature;
            this.changed.call();
        });
        // NVS-92 Przeciąganie temperatury - ciśnienie statyczne
        this.fanRecalced.lines.StaticPressure.changedTemperature(() => {
            this.dragEventElementType = "temperature";
            this.data.workPointTemperature = this.fanRecalced.lines.StaticPressure.temperature;
            this.data.workPointAirDensity = this.fanRecalced.lines.StaticPressure.density;
            this.store.state.fourthStepParametersSelected.temperature.value = this.fanRecalced.lines.StaticPressure.temperature;
            this.store.state.fourthStepParameters.temperature.value = this.fanRecalced.lines.StaticPressure.temperature;
            this.changed.call();
        });

        this._registerPerformanceAxises();
    }

    _registerPerformanceAxises() {
        for (let graph of Object.values(this.graphs)) {
            let axis = graph.graph.xs;

            unit.registerAxis('performance', axis, () => this.changed.call(this));//rejestruje oś, cyzli jesli zmienimy jednostę wydajności, to w tej osi też zostanie zmieniona

            axis.svg.oncontextmenu = e => {
                unit.menu(e, 'performance');//wyświetl menu z wyborem jednostki
            };

            axis.svg.addEventListener('click', e => {
                if (e.target.findParent(x => x.classList.contains('axisBtn'))) {//gdy klikamy na przycisk przy nazwie jednostki
                    unit.menu(e, 'performance');//wyświetl menu z wyborem jednostki
                }
            });
        }
    }

    /**
     * przygotowuje oś pod zmianę jednostki:
     * -ustawia jednostkę startową
     * -dodaje event prawego kalwisza myszy
     * -ustawia, że jak na innej osi zmienimy tę jednostkę, to w tej osi też się zmieni
     * @param graph
     * @param typeName
     * @param name
     */
    setGraphUnitsMenu(graph, typeName, name) {
        if (this.createGraphLine) {
            graph.graph.ys.config = {titleHTML: name, unit: unitsList[typeName].list[0]};
            unit.registerAxis(typeName, graph.graph.ys, () => this.changed.call(this));

            graph.graph.ys.svg.oncontextmenu = e => {
                unit.menu(e, typeName);
            };
            graph.graph.ys.svg.addEventListener('click', e => {
                if (e.target.findParent(x => x.classList.contains('axisBtn'))) {//czy kliknięto na rpzycisk przy nazwie osi
                    unit.menu(e, typeName);
                }
            });
        }
    }

    /**
     * wyswietl (dodaj do wykresów) linie oryginalne (bez przeliczania cześtotliwości)
     */
    showOryginal() {
        if (this.oryginalVisible) return;

        this.oryginalVisible = true;
        this.graphs.Noise.addLine(this.fan.lines.Noise);
        this.graphs.PowerOnShaft.addLine(this.fan.lines.PowerOnShaft);
        this.graphs.PowerOnShaftWithMaterial.addLine(this.fan.lines.PowerOnShaftWithMaterial);
        this.graphs.TotalPressure.addLine(this.fan.lines.TotalPressure);
        this.graphs.TotalEfficiency.addLine(this.fan.lines.TotalEfficiency);
        this.graphs.StaticPressure.addLine(this.fan.lines.StaticPressure);
        this.graphs.StaticPressureIncrease.addLine(this.fan.lines.StaticPressureIncrease);
        this.graphs.StaticEfficiency.addLine(this.fan.lines.StaticEfficiency);
        this.graphs.Amperage.addLine(this.fan.lines.Amperage);
        this.graphs.AmperageV2.addLine(this.fan.lines.AmperageV2);
        this.graphs.ElectricalPower.addLine(this.fan.lines.ElectricalPower);
    }

    /**
     * wyswietl (dodaj do wykresów) linie przeliczone
     */
    showCalced() {
        if (this.calcedVisible) return;

        this.calcedVisible = true;
        this.graphs.Noise.addLine(this.fanRecalced.lines.Noise);
        this.graphs.PowerOnShaft.addLine(this.fanRecalced.lines.PowerOnShaft);
        this.graphs.PowerOnShaftWithMaterial.addLine(this.fanRecalced.lines.PowerOnShaftWithMaterial);
        this.graphs.TotalPressure.addLine(this.fanRecalced.lines.TotalPressure);
        this.graphs.TotalEfficiency.addLine(this.fanRecalced.lines.TotalEfficiency);
        this.graphs.StaticPressure.addLine(this.fanRecalced.lines.StaticPressure);
        this.graphs.StaticPressureIncrease.addLine(this.fanRecalced.lines.StaticPressureIncrease);
        this.graphs.StaticEfficiency.addLine(this.fanRecalced.lines.StaticEfficiency);
        this.graphs.Amperage.addLine(this.fanRecalced.lines.Amperage);
        this.graphs.AmperageV2.addLine(this.fanRecalced.lines.AmperageV2);
        this.graphs.ElectricalPower.addLine(this.fanRecalced.lines.ElectricalPower);

    }

    /**
     * ukryj (skasuj z wykresów) linie oryginalne (bez przeliczania cześtotliwości)
     */
    hideOryginal() {
        if (!this.oryginalVisible) return;

        this.oryginalVisible = false;
        this.graphs.Noise.removeLine(this.fan.lines.Noise);
        this.graphs.PowerOnShaft.removeLine(this.fan.lines.PowerOnShaft);
        this.graphs.PowerOnShaftWithMaterial.removeLine(this.fan.lines.PowerOnShaftWithMaterial);
        this.graphs.TotalPressure.removeLine(this.fan.lines.TotalPressure);
        this.graphs.TotalEfficiency.removeLine(this.fan.lines.TotalEfficiency);
        this.graphs.StaticPressure.removeLine(this.fan.lines.StaticPressure);
        this.graphs.StaticPressureIncrease.removeLine(this.fan.lines.StaticPressureIncrease);
        this.graphs.StaticEfficiency.removeLine(this.fan.lines.StaticEfficiency);
        this.graphs.Amperage.removeLine(this.fan.lines.Amperage);
        this.graphs.AmperageV2.removeLine(this.fan.lines.AmperageV2);
        this.graphs.ElectricalPower.removeLine(this.fan.lines.ElectricalPower);
    }

    /**
     * ukryj (skasuj z wykresów) linie przeliczone
     */
    hideCalced() {
        if (!this.calcedVisible) return;

        this.calcedVisible = false;
        this.graphs.Noise.removeLine(this.fanRecalced.lines.Noise);
        this.graphs.PowerOnShaft.removeLine(this.fanRecalced.lines.PowerOnShaft);
        this.graphs.PowerOnShaftWithMaterial.removeLine(this.fanRecalced.lines.PowerOnShaftWithMaterial);
        this.graphs.TotalPressure.removeLine(this.fanRecalced.lines.TotalPressure);
        this.graphs.TotalEfficiency.removeLine(this.fanRecalced.lines.TotalEfficiency);
        this.graphs.StaticPressure.removeLine(this.fanRecalced.lines.StaticPressure);
        this.graphs.StaticPressureIncrease.removeLine(this.fanRecalced.lines.StaticPressureIncrease);
        this.graphs.StaticEfficiency.removeLine(this.fanRecalced.lines.StaticEfficiency);
        this.graphs.Amperage.removeLine(this.fan.lines.Amperage);
        this.graphs.AmperageV2.removeLine(this.fan.lines.AmperageV2);
        this.graphs.ElectricalPower.removeLine(this.fan.lines.ElectricalPower);
    }

    /**
     * Kliknięto na wykres ciśneinia całkowitego: ustaw punk rządany
     * @param e
     */
    totalPressureClick(e) {
        if (this.requestedPointEnabled) {
            let _number_of_fans = ((this.store && this.store.state && this.store.state.activeFun && this.store.state.activeFun.count) ? this.store.state.activeFun.count : (this.numberOfFans ? this.numberOfFans : 1));
            let max_number_of_fans = ((this.store && this.store.state && this.store.state.activeFun && this.store.state.activeFun.data && this.store.state.activeFun.data.number_of_fans) ? this.store.state.activeFun.data.number_of_fans : (this.numberOfFans ? this.numberOfFans : 1));
            let denominator = 1;

            if (max_number_of_fans > _number_of_fans)
                denominator = max_number_of_fans;

            this.dragEventElementType = "requestedPoint";
            this.data.workPointPerformance = e.x * denominator;
            this.data.workPointPerformanceHour = e.x * 3600 * denominator;
            this.data.workPointPressure = e.y;
            this.data.workPointPressureType = 'total';
            this.changed.call();
        }
    }

    /**
     * Kliknięto na wykres ciśneinia statycznego: ustaw punk rządany
     * @param e
     */
    staticPressureClick(e) {
        if (this.requestedPointEnabled) {
            this.dragEventElementType = "requestedPoint";
            this.data.workPointPerformance = e.x;
            this.data.workPointPerformanceHour = e.x * 3600;
            this.data.workPointPressure = e.y;
            this.data.workPointPressureType = 'static';
            this.changed.call();
        }
    }

    /**
     * Przerysowuje wykresy
     * Wykonuje się za każdym razem, jak coś się zmieni
     */
    draw() {
        if (!this._drawInited)
            this._drawInit();

        this.data.calcArea();
        this.data.calcInletArea();
        this.validateData();
        this.refreshLines();

        for (let name in this.fan.lines) {
            if (name == 'DynamicPressure') continue;
            this.fan.lines[name].line.config.color = 'rgba(0,0,0,.5)';//linie oryginalne są szare
            this.fanRecalced.lines[name].line.config.color = '#000000';//linie przelicozne są czarne
            this.fan.lines[name].isActive = false;//active na false znaczy, że to ejst wykres wyszarzony: wyswietla się, ale nie on nas interesuje
            this.fanRecalced.lines[name].isActive = true;
        }

        Object.values(this.graphs).forEach(graph => {
            graph.points.filter(p => p.type == 'workPoint' || p.type == 'maxPoint').forEach(p => graph.removePoint(p));//kasujemy punkty, żeby potem dodać nowe
        });

        this.showCalced();

        if (this.store && this.store.state.detailsShowOryginalFrequency)//zachowaj charakterystykę pierwotną
            this.showOryginal();
        else
            this.hideOryginal();

        this.drawRequestedLine();
        // NVS-86 Rysuję linię mocy zainstalowanej również na analizie szczegółowej na wykresie ciśnienia całkowitego
        this.drawInstalledPowerLine(this.graphs.TotalPressure, this.fanActive.lines.PowerOnShaftWithMaterial || this.fanActive.lines.PowerOnShaft, this.dragEventElementType);
        this._drawMaxEfficiency();

        for (let graph of Object.values(this.graphs)) {//lecimy po pojedynczych wykresach
            graph.minX = this.fanRecalced.min;
            graph.maxX = this.fanRecalced.max;

            if (this.oryginalVisible == true) {
                graph.minXOrg = this.fan.min;
                graph.maxXOrg = this.fan.max;
            } else {
                graph.minXOrg = graph.minX;
                graph.maxXOrg = graph.maxX;
            }

            if (this.canDraw) {
                try {
                    graph.draw();
                    graph.graph.svg.style.display = "block";
                } catch (ex) {
                    console.error(ex);
                    graph.graph.svg.style.display = "none";
                }
            } else {
                graph.graph.svg.style.display = "none";
            }
        }
    }

    /**
     * Wywalamy punkt rządany i charakterystykę instalacji
     * @private
     */
    _clearRequestedLine() {
        this.graphs.StaticPressure.removeLine(this._requestedLine);
        this.graphs.TotalPressure.removeLine(this._requestedLine);
        delete this._requestedLine;

        this.graphs.StaticPressure.removePoint(this.requestedPoint);
        this.graphs.TotalPressure.removePoint(this.requestedPoint);
        delete this.requestedPoint;
    }

    /**
     * wylicza punkt optymalny (nominalny)
     * wylicza punkt maksymalnej sprawności (zarówno statycznej jak i dynamciznej), z tego punktu bierzemy X i dla tego X wyliczamy wartości dla pozostałych wykresów
     */
    calcOptimalPoint() {
        this.optimal = {};
        let optimalPointTotal = this.fan.lines.TotalEfficiency.findMaximum(this.data.range_min, this.data.range_max);
        let optimalPointStatic = this.fan.lines.StaticEfficiency.findMaximum(this.data.range_min, this.data.range_max);
        this.optimal.TotalPreformance = this.graphs.TotalEfficiency.graph.xs.createValue(optimalPointTotal.x);
        this.optimal.StaticPreformance = this.graphs.StaticEfficiency.graph.xs.createValue(optimalPointStatic.x);
        this.optimal.TotalPressure = this.graphs.TotalPressure.graph.ys.createValue(this.fan.lines.TotalPressure.fun(optimalPointTotal.x));
        this.optimal.StaticPressure = this.graphs.StaticPressure.graph.ys.createValue(this.fan.lines.StaticPressure.fun(optimalPointStatic.x));
        this.optimal.StaticPressureIncrease = this.graphs.StaticPressureIncrease.graph.ys.createValue(this.fan.lines.StaticPressureIncrease.fun(optimalPointStatic.x));
        this.optimal.TotalEfficiency = this.graphs.TotalEfficiency.graph.ys.createValue(optimalPointTotal.y);
        this.optimal.StaticEfficiency = this.graphs.StaticEfficiency.graph.ys.createValue(optimalPointStatic.y);
        this.optimal.TotalPower = this.graphs.PowerOnShaft.graph.ys.createValue(this.fan.lines.PowerOnShaft.fun(optimalPointTotal.x));
        this.optimal.StaticPower = this.graphs.PowerOnShaft.graph.ys.createValue(this.fan.lines.PowerOnShaft.fun(optimalPointStatic.x));
        this.optimal.TotalPowerMaterial = this.graphs.PowerOnShaftWithMaterial.graph.ys.createValue(this.fan.lines.PowerOnShaftWithMaterial.fun(optimalPointTotal.x));
        this.optimal.StaticPowerMaterial = this.graphs.PowerOnShaftWithMaterial.graph.ys.createValue(this.fan.lines.PowerOnShaftWithMaterial.fun(optimalPointStatic.x));
        this.optimal.TotalNoise = this.graphs.Noise.graph.ys.createValue(this.fan.lines.Noise.fun(optimalPointTotal.x));
        this.optimal.StaticNoise = this.graphs.Noise.graph.ys.createValue(this.fan.lines.Noise.fun(optimalPointStatic.x));
        this.optimal.TotalAmperage = this.graphs.Amperage.graph.ys.createValue(this.fan.lines.Amperage.fun(optimalPointTotal.x));
        this.optimal.StaticAmperage = this.graphs.Amperage.graph.ys.createValue(this.fan.lines.Amperage.fun(optimalPointStatic.x));
        this.optimal.TotalAmperageV2 = this.graphs.AmperageV2.graph.ys.createValue(this.fan.lines.AmperageV2.fun(optimalPointTotal.x));
        this.optimal.StaticAmperageV2 = this.graphs.AmperageV2.graph.ys.createValue(this.fan.lines.AmperageV2.fun(optimalPointStatic.x));
        this.optimal.TotalElectricalPower = this.graphs.ElectricalPower.graph.ys.createValue(this.fan.lines.ElectricalPower.fun(optimalPointTotal.x));
        this.optimal.StaticElectricalPower = this.graphs.ElectricalPower.graph.ys.createValue(this.fan.lines.ElectricalPower.fun(optimalPointStatic.x));
        this.optimal.CharacteristicRatio = (Constants.airPressure + this.optimal.TotalPressure) / Constants.airPressure;
    }

    drawRequestedLine2() {
        let _number_of_fans = ((this.store && this.store.state && this.store.state.activeFun && this.store.state.activeFun.count) ? this.store.state.activeFun.count : 1);
        let requestedPressure = this.data.workPointPressure;
        let requestedPerformance = this.data.workPointPerformance;
        let isStatic = this.data.workPointPressureType === 'static';//total czy static
        this.workPointResult = {};

        if (!requestedPerformance || !requestedPressure) {//gdy nie mamy ciśnienia i wydajności rządanej, to nie ma lini
            this._clearRequestedLine();
            this.workPointResult = this.getDataByX(Number.NaN);//nie mam punktu pracy, ale trzeba odświerzyć to co się wyswietla w punkcie rpacy (szczególnie żeby jednostki się zaktualizowały) więc oblcizam dla NaN
            this.workPointResult.AirDensity = this.data.workPointAirDensity;
            this.workPointResult.AirDensityTotal = this.data.workPointAirDensityTotal;
            this.workPointResult.Frequency = this.data.workPointFrequency;
            return;
        }

        this._generateRequestedLine(true);
        //
        let pressurePolynomial;//wielomian ciśneinia (statycznego lub dynamicznego, zalezy co kliknięte jest)

        if (isStatic) {
            if (!this.graphs.StaticPressure.containsLine(this._requestedLine))
                this.graphs.StaticPressure.addLine(this._requestedLine);

            pressurePolynomial = this.fanActive.lines.StaticPressure.polynomial;
        } else {
            if (!this.graphs.TotalPressure.containsLine(this._requestedLine))
                this.graphs.TotalPressure.addLine(this._requestedLine);

            pressurePolynomial = this.fanActive.lines.TotalPressure.polynomial;
        }
        //wyznaczamy punkt przecięcia ciśnienia i charakterystyki instalacji
        //więc szukamy takeigo X, dla którego ciśnienie(x) = charakterystykaInstalacji(x)
        //więc przekształcamy to do równania charakterystykaInstalacji(x) - ciśnienie(x) = 0
        //więc wyznaczamy miejsca zerowe, ale tylko w zakresie w którym jest wentylator
        let zeroPoints = this._requestedLine.polynomial.subtract(pressurePolynomial).calcZeroPointsRange(this.fanActive.min / _number_of_fans, this.fanActive.max / _number_of_fans);
        let x;
        if (zeroPoints.length > 0) {
            x = zeroPoints[0];

            if (x)
                x = x * _number_of_fans;

            //zaznaczamy punkt pracy na wszystkich wykresach
            // this._drawWorkpoint(x, this.graphs.StaticPressure, this.fanActive.lines.StaticPressure);
            // this._drawWorkpoint(x, this.graphs.StaticEfficiency, this.fanActive.lines.StaticEfficiency);
            // this._drawWorkpoint(x, this.graphs.TotalPressure, this.fanActive.lines.TotalPressure);
            // this._drawWorkpoint(x, this.graphs.TotalPressure, this.fanRecalced.lines.DynamicPressure);
            // this._drawWorkpoint(x, this.graphs.TotalEfficiency, this.fanActive.lines.TotalEfficiency);
            // this._drawWorkpoint(x, this.graphs.PowerOnShaft, this.fanActive.lines.PowerOnShaft);
            // this._drawWorkpoint(x, this.graphs.PowerOnShaftWithMaterial, this.fanActive.lines.PowerOnShaftWithMaterial);
            // this._drawWorkpoint(x, this.graphs.Noise, this.fanActive.lines.Noise);
            // this._drawWorkpoint(x, this.graphs.Noise, this.fanActive.lines.Noise);
            // this._drawWorkpoint(x, this.graphs.Amperage, this.fanActive.lines.Amperage);
            // this._drawWorkpoint(x, this.graphs.AmperageV2, this.fanActive.lines.AmperageV2);
            // this._drawWorkpoint(x, this.graphs.ElectricalPower, this.fanActive.lines.ElectricalPower);
        } else {
            x = Number.NaN;
        }
        this.workPointResult = this.getDataByX(x);//wyniki punktu pracy są analogicznie jak punkt nominalny (optymalny)
        this.workPointResult.Frequency = this.data.workPointFrequency;

        // this._generateRequestedLine();
        // this._generateRequestedPoint();

        // if (isStatic) {
        //     if (!this.graphs.StaticPressure.containsPoint(this.requestedPoint))
        //         this.graphs.StaticPressure.addPoint(this.requestedPoint);
        //
        //     this.graphs.TotalPressure.removePoint(this.requestedPoint);
        // } else {
        //     if (!this.graphs.TotalPressure.containsPoint(this.requestedPoint))
        //         this.graphs.TotalPressure.addPoint(this.requestedPoint);
        //
        //     this.graphs.StaticPressure.removePoint(this.requestedPoint);
        // }
    }

    /**
     * rysuje charakterystyke instalacji
     */
    drawRequestedLine() {
        let _number_of_fans = ((this.store && this.store.state && this.store.state.activeFun && this.store.state.activeFun.count) ? this.store.state.activeFun.count : 1);
        let requestedPressure = this.data.workPointPressure;
        let requestedPerformance = this.data.workPointPerformance;
        let isStatic = this.data.workPointPressureType === 'static';//total czy static
        this.workPointResult = {};

        if (!requestedPerformance || !requestedPressure) {//gdy nie mamy ciśnienia i wydajności rządanej, to nie ma lini
            this._clearRequestedLine();
            this.workPointResult = this.getDataByX(Number.NaN);//nie mam punktu pracy, ale trzeba odświerzyć to co się wyswietla w punkcie rpacy (szczególnie żeby jednostki się zaktualizowały) więc oblcizam dla NaN
            this.workPointResult.AirDensity = this.data.workPointAirDensity;
            this.workPointResult.AirDensityTotal = this.data.workPointAirDensityTotal;
            this.workPointResult.Frequency = this.data.workPointFrequency;
            return;
        }

        this._generateRequestedLine(true);

        let pressurePolynomial;//wielomian ciśneinia (statycznego lub dynamicznego, zalezy co kliknięte jest)

        if (isStatic) {
            if (!this.graphs.StaticPressure.containsLine(this._requestedLine))
                this.graphs.StaticPressure.addLine(this._requestedLine);

            pressurePolynomial = this.fanActive.lines.StaticPressure.polynomial;
        } else {
            if (!this.graphs.TotalPressure.containsLine(this._requestedLine))
                this.graphs.TotalPressure.addLine(this._requestedLine);

            pressurePolynomial = this.fanActive.lines.TotalPressure.polynomial;
        }
        //wyznaczamy punkt przecięcia ciśnienia i charakterystyki instalacji
        //więc szukamy takeigo X, dla którego ciśnienie(x) = charakterystykaInstalacji(x)
        //więc przekształcamy to do równania charakterystykaInstalacji(x) - ciśnienie(x) = 0
        //więc wyznaczamy miejsca zerowe, ale tylko w zakresie w którym jest wentylator
        let zeroPoints = this._requestedLine.polynomial.subtract(pressurePolynomial).calcZeroPointsRange(this.fanActive.min / _number_of_fans, this.fanActive.max / _number_of_fans);
        let x;
        if (zeroPoints.length > 0) {
            x = zeroPoints[0];

            if (x)
                x = x * _number_of_fans;

            //zaznaczamy punkt pracy na wszystkich wykresach
            this._drawWorkpoint(x, this.graphs.StaticPressure, this.fanActive.lines.StaticPressure);
            this._drawWorkpoint(x, this.graphs.StaticPressureIncrease, this.fanActive.lines.StaticPressureIncrease);
            this._drawWorkpoint(x, this.graphs.StaticEfficiency, this.fanActive.lines.StaticEfficiency);
            this._drawWorkpoint(x, this.graphs.TotalPressure, this.fanActive.lines.TotalPressure);
            this._drawWorkpoint(x, this.graphs.TotalPressure, this.fanRecalced.lines.DynamicPressure);
            this._drawWorkpoint(x, this.graphs.TotalEfficiency, this.fanActive.lines.TotalEfficiency);
            this._drawWorkpoint(x, this.graphs.PowerOnShaft, this.fanActive.lines.PowerOnShaft);
            this._drawWorkpoint(x, this.graphs.PowerOnShaftWithMaterial, this.fanActive.lines.PowerOnShaftWithMaterial);
            this._drawWorkpoint(x, this.graphs.Noise, this.fanActive.lines.Noise);
            this._drawWorkpoint(x, this.graphs.Noise, this.fanActive.lines.Noise);
            this._drawWorkpoint(x, this.graphs.Amperage, this.fanActive.lines.Amperage);
            this._drawWorkpoint(x, this.graphs.AmperageV2, this.fanActive.lines.AmperageV2);
            this._drawWorkpoint(x, this.graphs.ElectricalPower, this.fanActive.lines.ElectricalPower);
        } else {
            x = Number.NaN;
        }
        this.workPointResult = this.getDataByX(x);//wyniki punktu pracy są analogicznie jak punkt nominalny (optymalny)
        this.workPointResult.Frequency = this.data.workPointFrequency;

        this._generateRequestedLine();
        this._generateRequestedPoint();

        if (isStatic) {
            if (!this.graphs.StaticPressure.containsPoint(this.requestedPoint))
                this.graphs.StaticPressure.addPoint(this.requestedPoint);

            this.graphs.TotalPressure.removePoint(this.requestedPoint);
        } else {
            if (!this.graphs.TotalPressure.containsPoint(this.requestedPoint))
                this.graphs.TotalPressure.addPoint(this.requestedPoint);

            this.graphs.StaticPressure.removePoint(this.requestedPoint);
        }
    }

    /**
     * dla danego X zwraca wyniki wsyzstkich lini
     * uzywane np. w punkcie nominalnym (optymalnym)
     * @param x
     */
    getDataByX(x) {
        let ret = {};
        ret.Performance = this.graphs.TotalPressure.graph.xs.createValue(x);
        if (x === undefined) {
            ret.Performance = this.graphs.TotalPressure.graph.xs.createValue(NaN);
        }
        ret.TotalPressure = this.graphs.TotalPressure.graph.ys.createValue(this.fanActive.lines.TotalPressure.fun(x));
        ret.TotalEfficiency = this.graphs.TotalEfficiency.graph.ys.createValue(this.fanActive.lines.TotalEfficiency.fun(x));
        ret.PowerOnShaft = this.graphs.PowerOnShaft.graph.ys.createValue(this.fanActive.lines.PowerOnShaft.fun(x));
        ret.AirDensity = this.data.workPointAirDensity;

        let workPointAirDensity = ret.AirDensity;
        let workPointAmount = this.data.workPointAmount;

        let airDensityCalculated = (x) => {
            if (x == 0)
                return 1.2;

            return workPointAirDensity + workPointAmount / 3.6 / x / 1000
        };

        ret.AirDensityTotal = airDensityCalculated(x);

        this.fanActive.lines.PowerOnShaftWithMaterial.polynomialOriginal = this.fanActive.lines.PowerOnShaft.polynomialOriginal.clone();
        this.fanActive.lines.PowerOnShaftWithMaterial.density = airDensityCalculated;
        this.fanActive.lines.PowerOnShaftWithMaterial.densityDenominator = 1.2;
        ret.PowerOnShaftWithMaterial = this.graphs.PowerOnShaftWithMaterial.graph.ys.createValue(this.fanActive.lines.PowerOnShaftWithMaterial.fun(x));

        ret.Noise = this.graphs.Noise.graph.ys.createValue(this.fanActive.lines.Noise.fun(x));
        ret.Amperage = this.graphs.Amperage.graph.ys.createValue(this.fanActive.lines.Amperage.fun(x));
        ret.AmperageV2 = this.graphs.Amperage.graph.ys.createValue(this.fanActive.lines.AmperageV2.fun(x));
        ret.ElectricalPower = this.graphs.ElectricalPower.graph.ys.createValue(this.fanActive.lines.ElectricalPower.fun(x));
        ret.StaticPressure = this.graphs.StaticPressure.graph.ys.createValue(this.fanActive.lines.StaticPressure.fun(x));
        ret.StaticPressureIncrease = this.graphs.StaticPressureIncrease.graph.ys.createValue(this.fanActive.lines.StaticPressureIncrease.fun(x));
        ret.StaticEfficiency = this.graphs.StaticEfficiency.graph.ys.createValue(this.fanActive.lines.StaticEfficiency.fun(x));
        ret.DynamicPressure = this.graphs.TotalPressure.graph.ys.createValue(this.fanRecalced.lines.DynamicPressure.fun(x));

        //ret.AirDensityTotal = this.data.workPointAirDensityTotal;

        ret.recalced = [];

        if (this.fan && this.fan.lines && this.fan.lines) {
            for (let line in this.fan.lines) {
                ret.recalced[line] = [];
                ret.recalced[line]["value"] = this.fan.lines[line].fun(x);
                ret.recalced[line]["minX"] = this.fan.lines[line].min;
                ret.recalced[line]["maxX"] = this.fan.lines[line].max;
            }
        }

        return ret;
    }

    /**
     * rysuje punkt maksymalnej sprawności (nominalny (optymalny))
     * @private
     */
    _drawMaxEfficiency() {
        let maxTotal = this.fanActive.lines.TotalEfficiency.findMaximum(this.fanActive.min, this.fanActive.max);
        let maxStatic = this.fanActive.lines.StaticEfficiency.findMaximum(this.fanActive.min, this.fanActive.max);
        let maxActive = (this.data.workPointPressureType == 'static') ? maxStatic : maxTotal;

        this._drawMaxEfficiencyPoint(this.graphs.TotalPressure, this.fanActive.lines.TotalPressure, maxActive.x);
        this._drawMaxEfficiencyPoint(this.graphs.PowerOnShaft, this.fanActive.lines.PowerOnShaft, maxActive.x);
        this._drawMaxEfficiencyPoint(this.graphs.PowerOnShaftWithMaterial, this.fanActive.lines.PowerOnShaftWithMaterial, maxActive.x);
        this._drawMaxEfficiencyPoint(this.graphs.Noise, this.fanActive.lines.Noise, maxActive.x);
        this._drawMaxEfficiencyPoint(this.graphs.Amperage, this.fanActive.lines.Amperage, maxActive.x);
        this._drawMaxEfficiencyPoint(this.graphs.AmperageV2, this.fanActive.lines.AmperageV2, maxActive.x);
        this._drawMaxEfficiencyPoint(this.graphs.ElectricalPower, this.fanActive.lines.ElectricalPower, maxActive.x);
        this._drawMaxEfficiencyPoint(this.graphs.StaticPressure, this.fanActive.lines.StaticPressure, maxActive.x);
        this._drawMaxEfficiencyPoint(this.graphs.StaticPressureIncrease, this.fanActive.lines.StaticPressureIncrease, maxActive.x);
        this._drawMaxEfficiencyPoint(this.graphs.TotalEfficiency, this.fanActive.lines.TotalEfficiency, maxActive.x);
        this._drawMaxEfficiencyPoint(this.graphs.StaticEfficiency, this.fanActive.lines.StaticEfficiency, maxActive.x);
    }

    getCountOfGraphLines(graph, type) {
        let count = 0;

        for (let line of graph._measureLines) {
            if (line instanceof type)
                count++;
        }

        return count;
    }

    removeAllLinesOfType(graph, type) {
        for (let i = graph._measureLines.length - 1; i >= 0; i--) {
            if (graph._measureLines[i] instanceof type)
                graph.removeMeasureLine(graph._measureLines[i]);
        }
    }

    moveColorToLast(arrayOfColors, color) {
        let index = 0;

        for (let curentColor of arrayOfColors) {
            if (curentColor === color) {
                arrayOfColors.splice(index, 1);
                arrayOfColors.push(color);
            }

            index++;
        }
    }

    moveColorToFirst(arrayOfColors, color) {
        arrayOfColors.forEach(function (item, i) {
            if (item === color) {
                arrayOfColors.splice(i, 1);
                arrayOfColors.unshift(item);
            }
        });
    }
}

export {fanGraphs};